import { useState, useEffect } from 'react';
import "../css/activities.css";

export default function Activites() {

    const [choice, setChoice] = useState("");
    const [details, setDetails] = useState("");
    const [error, setError] = useState("");

    const email = localStorage.getItem("inviteEmail");
    const isLocal = window.location.hostname === "localhost";
    const API_URL = isLocal ? "http://localhost:5000/api" // backend local sans /api 
        : "/api"; // backend prod avec /api

    //  Charger l'activité au démarrage
    useEffect(() => {
        const fetchChoices = async () => {
            try {
                // const response = await fetch("/choices");
                const response = await fetch(`${API_URL}/activities?email=${email}`);
                if (!response.ok) {
                    console.error("Erreur lors du chargement des choix");
                    return;
                }
                const data = await response.json();
                // const existing = data.find(item => item.email === email);

                if (data) {
                    setChoice(data.activity);
                    setDetails(data.activityDuration);
                }
                setError("");
            } catch (error) {
                setError("Impossible de récupérer la liste (serveur indisponible).");
            }
        };
        fetchChoices();
        // fetch("/api/choices")
        //   .then((res) => res.json())
        //   .then((data) => setChoicesList(data));
    }, [API_URL, email]);


    const handleSubmit = async () => {
        if (!choice || !details) {
            return alert("Merci de compléter les deux champs !");
        }

        // const isLocal = window.location.hostname === "localhost";
        // const API_URL = isLocal ? "http://localhost:5000/api" : "/api";

        const name = localStorage.getItem("invitePrenom") + " " + localStorage.getItem("inviteNom");
        const email = localStorage.getItem("inviteEmail");

        try {
            const response = await fetch(`${API_URL}/add-activity`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    name,
                    email,
                    activity: choice,
                    activityDuration: details
                })
            });

            if (!response.ok) throw new Error();

            alert("Votre activité a été enregistrée !");
            setChoice("");
            setDetails("");
            setError("");
        } catch {
            setError("Impossible d'enregistrer votre activité.");
        }
    };

    return (
        <div>
            <h1>Avant-scène 🎶🎹🎺🎸</h1>

            <div className="info-container">
                <img width='300' src="images/avantscene.jpg" alt="Ronquieres" className="info-photo" />
                <h2>Au programme :</h2>
                <ul className="activities-list">
                    <li>playlist collaborative</li>
                    <li>chateau gonflable</li>
                </ul>

                <p>Pour l'ambiance de la soirée, nous souhaitons que chaque invité choisisse 2 chansons pour la <a href="/playlist" className='btn btn-validate'>playlist partagée</a>.</p>
                <p>Les petits-bouts pourront s'amuser dans le château gonflable. Chaque enfant est sous la vigilence de son/ses parent(s).</p>
                <p>Pour les motivés, vous pouvez préparer une petite performance musicale, voire un jeu.</p>

            </div>
            
            <h2>Votre proposition :</h2>

            <div className="choice-container">
                <div className={`choice-box ${choice === "chant" ? "selected" : ""}`}
                    onClick={() => setChoice("chant")} >
                    1 chanson
                </div>
                <div className={`choice-box ${choice === "piano" ? "selected" : ""}`}
                    onClick={() => setChoice("piano")} >
                    1 morceau au piano
                </div>
                <div className={`choice-box ${choice === "instrument" ? "selected" : ""}`}
                    onClick={() => setChoice("instrument")} >
                    1 autre instrument
                </div>
                <div className={`choice-box ${choice === "discours" ? "selected" : ""}`}
                    onClick={() => setChoice("discours")} >
                    1 discours
                </div>
                <div className={`choice-box ${choice === "jeu" ? "selected" : ""}`}
                    onClick={() => setChoice("jeu")} >
                    Animer 1 jeu
                </div>
            </div>

            <div className="form">
                <p>Pour nous aider à organiser la journée, merci de nous dire quelle durée vous comptez consacrer à votre activité.</p>
                <textarea
                    placeholder={`Combien de temps durera votre activité ?`}
                    value={details}
                    onChange={(e) => setDetails(e.target.value)}
                />
            </div>
            <button className="btn btn-validate" onClick={handleSubmit}>Enregistrer ma proposition</button>
            {error && <p style={{ color: "red", marginTop: "10px" }}>{error}</p>}
            <p> Dress code "habille toi comme tu as envie" (n'achetez pas du neuf)</p>
            <img width='300' src="images/dresscode.jpg" alt="Ronquieres" className="info-photo" />
            <p>La décoration est ambiance vintage et seconde main avec une touche de vert.</p>

        </div>
    );
}



/* <p>Les petits-bouts pourront s'amuser dans le château gonflable.</p>
<p>Pour les motivés, vous pouvez préparer une petite performance musicale, voire un jeu.</p> */

/* <p className="strikethrough">
    (faut-il mettre ça ?)
</p> */

/* [PROTOCOLE D'ENVOI] */
